import { mainMenu } from "./mainMenu";
import { genericSearch } from "./genericSearch"
import initLenis from "./plugins/initLenis";
initLenis();
document.addEventListener("DOMContentLoaded", () => {
    mainMenu();
    const header = document.getElementById("mainHeader");
    const observer = new IntersectionObserver(
        ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
  { threshold: [1] }
    );

    observer.observe(header);
});
genericSearch();


// Newsletter form in footer (also used on homepage)

  (function () {
    const form = document.querySelector("#footer-newsletter-form");
    if (!form) return;
    const email = form.querySelector('input[name="email-address"]');
    const error = form.querySelector(".mailError");
    const submitButton = form.querySelector('button[type="submit"]');
    if (!email || !error) return;

    // touched flags to avoid showing validation messages on open
    let emailTouched = false;
    let oroiTouched = false;

    // Localized messages (all sourced from Umbraco dictionary via data-* attributes on the form)
    const messages = {
      required: form.dataset.msgRequired || "This field is required.",
      invalidEmail: form.dataset.msgInvalidEmail || "Please enter a valid email address.",
      successTitle: form.dataset.msgSuccessTitle || "Successfully submitted!",
      successText: form.dataset.msgSuccessText || "Thank you for subscribing to our newsletter.",
      errorGeneric: form.dataset.msgErrorGeneric || "Something went wrong. Please try again.",
      errorTitle: form.dataset.msgErrorTitle || "Error occurred!",
      errorText: form.dataset.msgErrorText || "Please try again later.",
    };

    // Simple email regex (reasonable balance of correctness and permissiveness)
    const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Checkbox "footer_oroi"
    const oroiInput = form.querySelector('input[name="footer_oroi"]');
    const oroiError = form.querySelector(".oroiError"); // The error span you added

    function showError() {
      email.setAttribute("aria-invalid", "true");
      error.style.display = "block";
    }

    function hideError() {
      email.removeAttribute("aria-invalid");
      error.style.display = "none";
    }

    // validateEmail(show = false) - when show=true, display error; otherwise be silent
    function validateEmail(show = false) {
        const val = (email.value || "").trim();

        const requiredMsg = messages.required;
        const wrongMsg = messages.invalidEmail;

        const isEmpty = val === "";
        const patternOk = emailRe.test(val);
        const ok = !isEmpty && patternOk;

        if (!ok) {
            // choose appropriate message
            if (isEmpty) {
                error.innerHTML = requiredMsg;
            } else {
                error.innerHTML = wrongMsg;
            }
            if (show || emailTouched) showError();
            else hideError();

            return false;
        }

        hideError();
        return true;
    }

    function validateOroi(show = false) {
      if (!oroiInput || !oroiError) return true;
      
      if (!oroiInput.checked) {
        if (show) {
          oroiError.style.display = "block";
          oroiError.style.color = "red";
          oroiError.style.fontSize = "12px";
          oroiError.style.marginTop = "4px";
          oroiError.textContent = oroiInput.getAttribute("data-error-message") || "You must accept the terms.";
          oroiInput.setAttribute("aria-invalid", "true");
        } else {
          oroiError.style.display = "none";
          oroiInput.removeAttribute("aria-invalid");
        }
        return false;
      } else {
        oroiError.style.display = "none";
        oroiInput.removeAttribute("aria-invalid");
        return true;
      }
    }

    // run silent validation checks (do not show errors) to report overall validity.
    // NOTE: we intentionally do NOT disable the submit button here. A disabled button
    // is not clickable and shows no pointer cursor; instead we always allow the click
    // and surface validation errors from the submit handler.
    function updateSubmitState() {
      const emailOk = validateEmail(false);
      const oroiOk = validateOroi(false);
      return emailOk && oroiOk;
    }

    if (oroiInput && oroiError) {
      oroiInput.addEventListener("change", () => {
        oroiTouched = true; // Mark as touched when changed
        validateOroi(true); // Always show validation on change
        updateSubmitState();
      });
      oroiInput.addEventListener("blur", () => {
        oroiTouched = true;
        validateOroi(true);
      });
    }

    // Add a comprehensive submit validator (runs before the existing submit handler)
    form.addEventListener("submit", function (e) {
      // mark all controls as touched so errors are shown on submit
      e.preventDefault();
      emailTouched = true;
      oroiTouched = true;

      const emailValid = validateEmail(true);
      const oroiValid = validateOroi(true);

      if (!emailValid || !oroiValid) {
        // focus first invalid control
        if (!emailValid) {
          email.focus();
        } else if (!oroiValid) {
          oroiInput.focus();
        }
      } else {
        submitButton.classList.add("sending")
        submitButton.disabled = true;
        // all valid, allow submit to proceed
        const submitObject = {
          Originator: "Footer",
          Email: email.value.trim(),
          Gender: "",
          AcceptTerms: !!(oroiInput && oroiInput.checked),
        };

        const tokenElement = document.getElementsByName(
          "__RequestVerificationToken",
        )[0];
        const token = tokenElement ? tokenElement.value : null;

        const headers = {
          "Content-Type": "application/json; charset=utf-8",
        };
        if (token) {
          headers["RequestVerificationToken"] = token;
        }

        fetch("/umbraco/surface/Newsletter/SubmitNewsletter", {
          method: "POST",
          headers: headers,
          body: JSON.stringify(submitObject),
        })
          .then((response) => {
            submitButton.classList.remove("sending");
            submitButton.disabled = false;
            if (!response.ok) {
              throw new Error(response.message || messages.errorGeneric);
            }
            return response.json();
          })
          .then((result) => {
            const responseEl = document.querySelector("#footer-newsletter-form");
            if (responseEl) {
              if (result.statusCode === 200) {
                // Success message
                responseEl.innerHTML = `
                            <div class="flex">
                                <div class="shrink-0">
                                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="size-5 text-green-400">
                                        <path fill-rule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.236 4.53L8.53 10.53a.75.75 0 0 0-1.06 1.061l2.03 2.03a.75.75 0 0 0 1.137-.089l3.857-5.401Z" clip-rule="evenodd"></path>
                                    </svg>
                                </div>
                                <div class="ml-3">
                                    <p class="text-sm font-medium text-green-800">${messages.successTitle}</p>
                                    <p class="mt-1 text-sm text-green-700">${messages.successText}</p>
                                </div>
                            </div>`;
              } else {
                // Error message (e.g. validation failed / server error)
                responseEl.innerHTML = `
                        <div class="rounded-md bg-red-50 p-4">
                            <div class="flex">
                                <div class="shrink-0">
                                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="size-5 text-red-400">
                                        <path fill-rule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8.28 7.22a.75.75 0 0 0-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 1 0 1.06 1.06L10 11.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L11.06 10l1.72-1.72a.75.75 0 0 0-1.06-1.06L10 8.94 8.28 7.22Z" clip-rule="evenodd"></path>
                                    </svg>
                                </div>
                                <div class="ml-3">
                                    <p class="text-sm font-medium text-red-800">${result.message || messages.errorGeneric}</p>
                                </div>
                            </div>
                        </div>`;
              }
            }
          })
          .catch((error) => {
            submitButton.classList.remove("sending");
            submitButton.disabled = false;
            const responseEl = document.querySelector("#footer-newsletter-form");
            if (responseEl) {
              responseEl.innerHTML = `
                        <div class="rounded-md bg-red-50 p-4">
                            <div class="flex">
                                <div class="shrink-0">
                                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true" class="size-5 text-red-400">
                                        <path fill-rule="evenodd" d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8.28 7.22a.75.75 0 0 0-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 1 0 1.06 1.06L10 11.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L11.06 10l1.72-1.72a.75.75 0 0 0-1.06-1.06L10 8.94 8.28 7.22Z" clip-rule="evenodd"></path>
                                    </svg>
                                </div>
                                <div class="ml-3">
                                    <p class="text-sm font-medium text-red-800">${messages.errorTitle}</p>
                                    <p class="mt-1 text-sm text-red-700">${messages.errorText}</p>
                                </div>
                            </div>
                        </div>`;
            }
            console.error("Error:", error);
          });
      }
    });

    // Ensure accessible IDs / attributes
    if (!email.id) email.id = "newsletter-email";
    error.id = error.id || "email-error";
    error.setAttribute("role", "alert");
    error.style.display = "none";
    email.setAttribute("aria-describedby", error.id);
    // Button stays enabled/clickable at all times; validation is surfaced on submit.

    // This is an observer to check for all data-animate-visible="false" and turn them to true when they enter the viewport
    const animatedElements = document.querySelectorAll(
      '[data-animate][data-animate-visible="false"]',
    );
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };
    const animateObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.setAttribute("data-animate-visible", "true");
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    animatedElements.forEach((el) => {
      animateObserver.observe(el);
    });


    // ensure interactive controls update the submit button state
    // input: update state and show validation if field was already touched
    email.addEventListener("input", function () {
        emailTouched = true;
        validateEmail(true);
        updateSubmitState();
    });
    // blur: mark touched and run visible validation
    email.addEventListener("blur", function () {
        emailTouched = true;
        validateEmail(true);
        updateSubmitState();
    });

    // initial check (silent, so no errors shown on open)
    updateSubmitState();

    // Live feedback: keep input listener silent (already handled above). The explicit validate listeners below
    // ensure we do not show errors while the dialog opens; only on blur/show.
})();
